import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {AspectRatioCard} from '@homeaway/react-aspect-ratio-card';
import {pushEdapEvent} from '../../../utils/edap';
import {
    goToPinnedSerp,
    goToSerp,
    showDatesPopup,
} from '../../../actions/search';
import {LAZY_LOAD_OFFSET} from '../../../utils/constants';
import LazyLoad from '../../common/lazy-load/LazyLoad';
import PlaceholderImage from '../../common/carousel/Placeholder';
import {CommonDescription, listingCaption} from '../../common/carousel/common';
import CardDescription from '../../common/carousel/CardDescription';
import Placeholder from '../../common/carousel/Placeholder';

export function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

export function mapStateToProps({options = {}, destination: {details = {}}}) {
    return {
        expandedTripboardButton: options.expandedTripboardButton,
        simpleName: details.simpleName,
    };
}

export class CardComponent extends PureComponent {
    static propTypes = {
        cardAspectRatio: PropTypes.string,
    };

    static defaultProps = {
        cardAspectRatio: '4x3',
    };

    handlePropertyClick = ({
        tripleId,
        lbsId,
        thumbnailUrl,
        moduleNumber,
        cardNumber,
        searchURL,
    }) => (e) => {
        if (e.defaultPrevented) {
            return;
        }

        e.preventDefault();
        const data = {
            actionlocation: `destination-properties-module-${moduleNumber}`,
            listingid: tripleId,
            eventlbsuuid: lbsId,
            eventrefinements: `position-${cardNumber}`,
        };

        pushEdapEvent('property.tile.click', data);

        this.props.dispatch(
            showDatesPopup({
                tripleId,
                thumbnailUrl,
                dateModalTarget: 'new',
                goToSerpAction: tripleId ? goToPinnedSerp : goToSerp,
                listingUri: searchURL,
            })
        );
    };

    handleTripboardClick = (evt) => {
        evt.preventDefault();
    };

    renderTripboard({moduleNumber}) {
        const {
            expandedTripboardButton,
            listing,
            simpleName,
            tripboardComponent: TripboardComponent,
        } = this.props;

        if (!TripboardComponent) {
            return null;
        }

        const {
            propertyName,
            review,
            searchURL,
            thumbnailUrl,
            tripleId,
        } = listing;

        return (
            TripboardComponent && (
                <TripboardComponent
                    actionlocation={`destination-properties-module-${moduleNumber}`}
                    expandedButton={expandedTripboardButton}
                    headline={propertyName}
                    href={searchURL}
                    listingId={tripleId}
                    newBoardName={simpleName}
                    onClick={this.handleTripboardClick}
                    averageRating={review.averageRating}
                    reviewCount={review.reviewCount}
                    thumbnailUrl={thumbnailUrl}
                />
            )
        );
    }

    render() {
        const {
            aspectRatio = '4x3',
            cardNumber,
            isMobile,
            lbsId,
            listing,
            moduleNumber,
        } = this.props;

        const {
            instantBookableText,
            price,
            propertyName,
            review,
            searchURL,
            thumbnailUrl,
            toplineDescription: subcaption,
            tripleId,
        } = listing;

        const offset = LAZY_LOAD_OFFSET[isMobile ? 'MOBILE' : 'DEFAULT'];

        const placeholder = <PlaceholderImage />;

        const caption = listingCaption({
            toplineDescription: propertyName,
        });

        return (
            <a
                href={searchURL}
                role="button"
                onClick={this.handlePropertyClick({
                    tripleId,
                    lbsId,
                    thumbnailUrl,
                    moduleNumber,
                    cardNumber,
                    searchURL,
                })}
                className={'RatioCard'}
            >
                <AspectRatioCard
                    aspectRatio={aspectRatio}
                    key={thumbnailUrl}
                    hasHover={thumbnailUrl === '' ? false : true}
                >
                    <div
                        key={'figure'}
                        data-slot={'figure'}
                        className={'RatioCard__img-container'}
                    >
                        <LazyLoad offset={offset} placeholder={placeholder}>
                            {thumbnailUrl === '' ? (
                                <Placeholder />
                            ) : (
                                <img src={thumbnailUrl} alt={propertyName} />
                            )}
                        </LazyLoad>
                    </div>
                    <div
                        key={'content'}
                        data-slot={'content'}
                        className={'CommonRatioCard__footer'}
                    >
                        {this.renderTripboard({moduleNumber})}
                        {caption}
                        {subcaption && <CardDescription text={subcaption} />}
                        <CommonDescription
                            instantBookable={instantBookableText}
                            price={price}
                            review={review}
                        />
                    </div>
                </AspectRatioCard>
            </a>
        );
    }
}

export const Card = connect(mapStateToProps, mapDispatchToProps)(CardComponent);

Card.displayName = 'Card';

export default Card;
